// src/utils/planRules.js
export const PLAN = {
  NONE: "none", // no plan selected yet
  FREE: "free",
  STARTER: "starter",
  PERFORMANCE: "performance",
};

export const RULES = {
  [PLAN.NONE]: {
    label: "No plan",
    allowOneFirstRecording: true, // exactly 1 recording total
    lockResults: true,
  },
  [PLAN.FREE]: {
    label: "Freemium",
    // Unlimited recordings; users pay to unlock results.
    cooldownDays: 0,
    quotas: { exertionPerMonth: Infinity, spirometryPerMonth: Infinity },
    lockResults: true,
    freebies: {
      // Grant 1 Lung Fitness Score (spirometry-derived) per rolling 30 days
      lungFitnessPer30Days: 1,
    },
    locks: {
      lungAge: true,
      lungFitness: true,
      breathingTrace: true,
      respiratoryRate: false,
      breathingRecovery: true,
      recoveryTime: true,
      recoveryCurve: true,
      totalVolume: true,
    },
  },
  [PLAN.STARTER]: {
    label: "Starter",
    cooldownDays: 0,
    quotas: { exertionPerMonth: 4, spirometryPerMonth: Infinity },
    lockResults: false,
    locks: {
      lungAge: false,
      lungFitness: false,
      breathingTrace: false,
      respiratoryRate: false,
      breathingRecovery: true,
      recoveryTime: false,
      recoveryCurve: false,
      totalVolume: true,
    },
  },
  [PLAN.PERFORMANCE]: {
    label: "Performance",
    cooldownDays: 0,
    quotas: { exertionPerMonth: Infinity, spirometryPerMonth: Infinity },
    lockResults: false,
    locks: {
      lungAge: false,
      lungFitness: false,
      breathingTrace: false,
      respiratoryRate: false,
      breathingRecovery: false,
      recoveryTime: false,
      recoveryCurve: false,
      totalVolume: false,
    },
  },
};

export function countAll(items = [], kind) {
  return items.filter((it) => (kind ? it.kind === kind : true)).length;
}
export function countInLastDays(items = [], days = 30, kind) {
  const since = Date.now() - days * 24 * 60 * 60 * 1000;
  return items.filter((it) => {
    if (!it?.timestamp) return false;
    if (it.timestamp < since) return false;
    if (kind && it.kind !== kind) return false;
    return true;
  }).length;
}
